/**
 * The admin app's runtime environment (ADR-0084): its API origin, the
 * customer web origin and the environment name, derived from the page's own
 * hostname.
 *
 * One bundle serves the local stack, staging and production, so this is the
 * only place the admin app reads VITE_API_BASE_URL and VITE_WEB_BASE_URL.
 * Those are development overrides only: on a deployment host the hostname
 * decides. Resolved on every call so a test can move the page or stub an
 * override.
 */
import { resolveRuntimeEnvironment, type RuntimeEnvironment } from '@speaking-coach/shared-types'

export function runtimeEnvironment(): RuntimeEnvironment {
  return resolveRuntimeEnvironment(window.location, {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
    webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
  })
}

export function apiBaseUrl(): string {
  return runtimeEnvironment().apiBaseUrl
}
